import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf74d18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = { class: "tw-w-full tw-bg-[#F8FBFD] tw-border-[#DFDFDF] tw-border-solid tw-border-[1px] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-5" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-start" }
const _hoisted_5 = { class: "offer-attachments tw-grid tw-w-full" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end tw-pt-6 tw-box-border tw-border-t-dashed-custom tw-gap-4" }

import { ref } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage, imageExtensions } from "@/core/utils/common";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { DisputeRequestStatusEnums } from "@/core/enums/ProjectsEnum";
import Button from "./ui/general/Button.vue";
import Text from "./ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOfferProjectModel',
  props: {
  statement: {
    type: String,
    default: null,
  },
  userMessageAttachments: {
    type: Array,
  },
  isSenderUser: {
    type: Boolean,
    default: true,
  },
  disputeOffer: {
    type: Object,
    default: null,
  },
  messageId: {
    type: Number,
  },
  isShowButton: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  "on-close",
  "on-submit",
  "on-accept-offer",
  "on-reject-offer",
],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;
const internalInstance = getCurrentInstance();
const isLoading = ref<boolean>(false);

const isImageType = (attachments: any) => {
  return imageExtensions.some((ext) =>
    attachments?.publicURL?.toLowerCase().endsWith(ext)
  );
};

const ispdf = (attachments: any) => {
  return attachments?.publicURL?.toLowerCase().endsWith(".pdf");
};

const onAcceptOffer = async () => {
  try {
    isLoading.value = true;
    const payload = {
      disputeOfferId: props.disputeOffer.id,
      status: DisputeRequestStatusEnums.ACCEPTED,
    };
    await store.dispatch(`${PROJECT_STORE}/acceptDisputeProjectOffer`, payload);

    emits("on-accept-offer", {
      messageId: props.messageId,
    });
  } catch (error) {
    displayToastMessage(
      internalInstance,
      "Failed to accept dispute project Please try again.",
      "error"
    );
  } finally {
    isLoading.value = false;
  }
};

const onRejectOffer = async () => {
  try {
    isLoading.value = true;
    const payload = {
      disputeOfferId: props.disputeOffer.id,
      status: DisputeRequestStatusEnums.REJECTED,
      reject_reason: "",
    };
    await store.dispatch(`${PROJECT_STORE}/rejectDisputeProjectOffer`, payload);
    emits("on-reject-offer", {
      messageId: props.messageId,
    });
  } catch (error) {
    displayToastMessage(
      internalInstance,
      "Failed to reject dispute project Please try again.",
      "error"
    );
  } finally {
    isLoading.value = false;
  }
};

const onClickBackButton = () => {
  return emits("on-close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    headerTitle: "View Offer Proposal",
    width: "588px",
    isTitleStrong: true,
    borderRadius: "20px"
  }, _createSlots({
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Text, {
              variant: "h6",
              lineHeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Statement")
              ]),
              _: 1
            }),
            _createVNode(Text, {
              variant: "h6",
              textWeight: "400",
              textAlign: "left",
              lineHeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.statement), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Text, { variant: "h6" }, {
              default: _withCtx(() => [
                _createTextVNode("Attachments")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.userMessageAttachments?.slice(0, 5), (attachment, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tw-rounded-[8.72px] tw-overflow-hidden tw-w-full tw-h-[94px]",
                  key: index
                }, [
                  (isImageType(attachment))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: attachment?.publicURL,
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: attachment?.publicURL,
                          alt: "Image",
                          class: "tw-w-full tw-h-full tw-object-cover"
                        }, null, 8, _hoisted_7)
                      ], 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: attachment?.publicURL,
                        target: "_blank"
                      }, [
                        (ispdf(attachment?.publicURL))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "tw-w-full tw-h-full tw-object-cover",
                              src: require('@/assets/icons/pdf-document-icon.svg'),
                              alt: "icon"
                            }, null, 8, _hoisted_9))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: "tw-w-full tw-h-full tw-object-cover",
                              src: require('@/assets/icons/documents.svg'),
                              alt: "icon"
                            }, null, 8, _hoisted_10))
                      ], 8, _hoisted_8))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 2
  }, [
    (
        props.isShowButton &&
        !props.isSenderUser &&
        props.disputeOffer?.status === _unref(DisputeRequestStatusEnums).PENDING
      )
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("section", _hoisted_11, [
              _createVNode(Button, {
                class: "!tw-w-auto",
                variant: "secondary",
                label: "Reject",
                onClick: onRejectOffer
              }),
              _createVNode(Button, {
                class: "!tw-w-auto",
                variant: "accent",
                label: "Accept",
                onClick: onAcceptOffer
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})